import {useListView} from '../../core/ListViewProvider'
import {ClientsListToolbar} from './ClientListToolbar'
import {ClientsListGrouping} from './ClientsListGrouping'
import {ClientsListSearchComponent} from './ClientsListSearchComponent'

const ClientsListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <ClientsListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {selected.length > 0 ? <ClientsListGrouping /> : <ClientsListToolbar />}
      </div>
    </div>
  )
}

export {ClientsListHeader}
